import React from "react";
var __jsx = React.createElement;
import { useState, useEffect, useRef, forwardRef } from "react";
import { AddSwipeUp } from "@/utils/GlobalJavascriptFunction";
import stl from "./Story.module.css";
var Story = /*#__PURE__*/forwardRef(function Story(_ref, ref) {
  var children = _ref.children,
    showStoryMode = _ref.showStoryMode,
    closeStory = _ref.closeStory,
    _ref$activeStory = _ref.activeStory,
    activeStory = _ref$activeStory === void 0 ? 0 : _ref$activeStory,
    BGColor = _ref.BGColor;
  var _useState = useState(Array.isArray(children) && children.length > 1 ? children : [children]),
    stories = _useState[0],
    setStories = _useState[1];
  var _useState2 = useState(activeStory),
    activeStoryIndex = _useState2[0],
    setActiveStoryIndex = _useState2[1];
  var _useState3 = useState(false),
    animateCloseMobile = _useState3[0],
    setAnimateCloseMobile = _useState3[1];
  var timerRef = useRef();

  // Initial setup
  useEffect(function () {
    startTimer();
    var body = document.querySelector("body");
    if (body) AddSwipeUp(body, closeStoryMode);
    return function () {
      return clearTimeout(timerRef.current);
    };
  }, []);

  // Update when children or BGColor changes
  useEffect(function () {
    setStories(Array.isArray(children) && children.length > 1 ? children : [children]);
  }, [children]);
  var startTimer = function startTimer() {
    timerRef.current = setTimeout(function () {
      setNewStory(activeStoryIndex + 1);
    }, 12000);
  };
  var setNewStory = function setNewStory(newIndex) {
    clearTimeout(timerRef.current);
    if (newIndex > stories.length - 1) {
      setActiveStoryIndex(0);
      closeStoryMode();
      return;
    }

    // Calculate bounded index (prevent out of range)
    var boundedIndex = newIndex < 0 ? stories.length - 1 : newIndex;
    setActiveStoryIndex(boundedIndex);
    startTimer();
  };
  var closeStoryMode = function closeStoryMode() {
    if (!showStoryMode) return;
    clearTimeout(timerRef.current);
    var body = document.querySelector("body");
    if (body) body.style.overflow = "hidden";
    setAnimateCloseMobile(true);
    setTimeout(function () {
      setAnimateCloseMobile(false);
      if (body) body.style.overflow = "";
      closeStory();
    }, 200);
  };
  if (!showStoryMode) return null;
  var containerClasses = [stl.stryContainer, stl.openStry, animateCloseMobile ? stl.animateCloseMobile : undefined].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: containerClasses,
    onClick: function onClick(e) {
      return e.target === e.currentTarget && closeStoryMode();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.strysubContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.clsStry,
    onClick: closeStoryMode
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.rsst,
    onClick: function onClick() {
      return setNewStory(activeStoryIndex - 1);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.lsst,
    onClick: function onClick() {
      return setNewStory(activeStoryIndex + 1);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.allstry,
    "data-strycount": "0",
    style: {
      background: BGColor || ""
    }
  }, stories[activeStoryIndex], /*#__PURE__*/React.createElement("div", {
    className: stl.allstryLine
  }, stories.map(function (_, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: "stry".concat(i),
      style: {
        width: "calc(100% / ".concat(stories.length, " - 5px)")
      },
      className: i > activeStoryIndex ? "" : i === activeStoryIndex ? stl.inview : stl.doneView
    });
  })))));
});
export default Story;